/*============================================================================
  Cart Drawer Upsell - Quick Add to Cart
  "Votre routine serait plus complète avec" - Ajout en 1 clic avec tracking
  + _trigger : attribution du vrai produit déclencheur (lu depuis data-trigger)
==============================================================================*/

(function() {
  'use strict';

  var selectors = {
    addButton: '.cart-upsell-card__add-btn'
  };

  var classes = {
    loading: 'is-loading',
    success: 'is-success'
  };

  function CartDrawerUpsell() {
    this.init();
  }

  CartDrawerUpsell.prototype = {

    init: function() {
      document.addEventListener('click', this.handleAddClick.bind(this));
      document.addEventListener('CartDrawer:open', this.addCloseButton.bind(this));

      /*============================================================================
        Guard Personal Shopper — ne pas ouvrir le drawer upsell si l'ATC
        vient du personal shopper (from_personal_shopper: true dans le detail)
      ==============================================================================*/
      document.addEventListener('ajaxProduct:added', function(e) {
        if (e.detail && e.detail.from_personal_shopper) {
          setTimeout(function() {
            var headerCart = document.getElementById('HeaderCart');
            if (headerCart && headerCart.classList.contains('is-active')) {
              headerCart.classList.remove('is-active');
            }
          }, 50);
          return;
        }
      });

      this.watchDrawerState();
      this.observeUpsellSection();
      this.observeReviewsSlider();
    },

    /*============================================================================
      watchDrawerState
      Observe .is-active sur #HeaderCart directement.
      À l'ouverture : déplacer vers body pour sortir du stacking context
      de .header-section (z-index:6 sticky).
      À la fermeture : remettre à sa place d'origine.
    ==============================================================================*/
    watchDrawerState: function() {
      if (window.innerWidth < 1024) return;
      var self = this;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;

      this._headerCartParent = headerCart.parentNode;
      this._headerCartNextSibling = headerCart.nextSibling;

      self._syncActiveState(headerCart);

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' &&
              mutations[i].attributeName === 'class' &&
              mutations[i].target === headerCart) {
            self._syncActiveState(headerCart);
          }
        }
      });

      observer.observe(headerCart, { attributes: true });
      this._stateObserver = observer;
    },

    _syncActiveState: function(headerCart) {
      if (!headerCart) return;

      var isOpen = headerCart.classList.contains('is-active');

      if (isOpen && headerCart.parentNode !== document.body) {
        this._headerCartParent = headerCart.parentNode;
        this._headerCartNextSibling = headerCart.nextSibling;
        document.body.appendChild(headerCart);
        headerCart.style.top = '38px';
        this.addCloseButton();
      } else if (!isOpen && headerCart.parentNode === document.body) {
        headerCart.style.top = '';
        if (this._headerCartParent) {
          if (this._headerCartNextSibling) {
            this._headerCartParent.insertBefore(headerCart, this._headerCartNextSibling);
          } else {
            this._headerCartParent.appendChild(headerCart);
          }
        }
      }
    },

    /*============================================================================
      MutationObserver — [data-cart-upsell]
    ==============================================================================*/
    observeUpsellSection: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var upsellSection = null;
            if (node.hasAttribute && node.hasAttribute('data-cart-upsell')) {
              upsellSection = node;
            } else if (node.querySelector) {
              upsellSection = node.querySelector('[data-cart-upsell]');
            }

            if (upsellSection) {
              if (upsellSection.closest('.cart-upsell-panel')) continue;
              self.moveUpsellToPanel(upsellSection);
              self.addCloseButton();
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._upsellObserver = observer;
    },

    /*============================================================================
      MutationObserver — [data-upsell-reviews]
      Guard : on n'initialise le slider que si le bloc reviews n'est pas déjà
      marqué comme initialisé (_reviewsInitialized). Le déplacement de
      #HeaderCart vers body déclenche le MutationObserver une deuxième fois —
      sans ce guard, initReviewsSlider serait appelé deux fois et deux items
      .is-active se retrouveraient visibles simultanément.
    ==============================================================================*/
    observeReviewsSlider: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var existing = document.querySelector('[data-upsell-reviews]');
      if (existing && !existing._reviewsInitialized) {
        existing._reviewsInitialized = true;
        self.initReviewsSlider(existing);
      }

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var reviewsBlock = null;
            if (node.hasAttribute && node.hasAttribute('data-upsell-reviews')) {
              reviewsBlock = node;
            } else if (node.querySelector) {
              reviewsBlock = node.querySelector('[data-upsell-reviews]');
            }

            // Guard : ne pas réinitialiser si déjà initialisé
            if (reviewsBlock && !reviewsBlock._reviewsInitialized) {
              reviewsBlock._reviewsInitialized = true;
              self.initReviewsSlider(reviewsBlock);
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._reviewsObserver = observer;
    },

    /*============================================================================
      Reviews slider — rotation toutes les 7s
      Nettoie toutes les classes .is-active existantes avant de démarrer
      pour éviter tout doublon résiduel.
    ==============================================================================*/
    initReviewsSlider: function(reviewsBlock) {
      var track = reviewsBlock.querySelector('[data-reviews-track]');
      if (!track) return;

      if (this._reviewsTimer) {
        clearInterval(this._reviewsTimer);
        this._reviewsTimer = null;
      }

      var items = track.querySelectorAll('.cart-upsell-reviews__item');
      if (items.length === 0) return;

      // Nettoyer toutes les classes is-active existantes
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-active');
      }

      var current = 0;
      items[current].classList.add('is-active');

      this._reviewsTimer = setInterval(function() {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 7000);
    },

    /*============================================================================
      Colonne upsell desktop
    ==============================================================================*/
    moveUpsellToPanel: function(upsellSection) {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (!upsellSection) return;

      var panel = headerCart.querySelector('.cart-upsell-panel');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'cart-upsell-panel';
        headerCart.insertBefore(panel, headerCart.firstChild);
      }

      var existing = panel.querySelector('[data-cart-upsell]');
      if (existing && existing !== upsellSection) existing.remove();

      panel.appendChild(upsellSection);
    },

    /*============================================================================
      Bouton fermeture — .js-close-header-cart (bouton natif Fetch)
    ==============================================================================*/
    addCloseButton: function() {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (headerCart.querySelector('.cart-upsell-close-btn')) return;

      var btn = document.createElement('button');
      btn.className = 'cart-upsell-close-btn';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', 'Fermer le panier');
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

      btn.addEventListener('click', function() {
        var headerCart = document.getElementById('HeaderCart');
        if (headerCart) headerCart.classList.remove('is-active');
      });

      headerCart.appendChild(btn);
    },

    handleAddClick: function(evt) {
      var btn = evt.target.closest(selectors.addButton);
      if (!btn) return;

      evt.preventDefault();
      evt.stopPropagation();

      if (btn.classList.contains(classes.loading)) return;

      var variantId = btn.dataset.variantId;
      var productTitle = btn.dataset.productTitle;
      var productPrice = btn.dataset.productPrice;

      if (!variantId) {
        console.error('Cart Upsell: Variant ID manquant');
        return;
      }

      this.addToCart(btn, variantId, productTitle, productPrice);
    },

    addToCart: function(btn, variantId, productTitle, productPrice) {
      btn.classList.add(classes.loading);

      var deviceType = window.innerWidth < 768 ? 'mobile' : 'desktop';
      var card = btn.closest('.cart-upsell-card');

      // Produit déclencheur : lu sur la section [data-cart-upsell] (data-trigger)
      var upsellRoot = btn.closest('[data-cart-upsell]');
      var trigger = upsellRoot && upsellRoot.dataset.trigger ? upsellRoot.dataset.trigger : '';

      var props = {
        '_source': 'cart_upsell',
        '_device': deviceType
      };
      if (trigger) props['_trigger'] = trigger;

      var formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: props
        }]
      };

      var cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cartAdd
        ? window.theme.routes.cartAdd
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422 || data.status === 'bad_request') {
          this.showError(btn, data.description || data.message);
        } else {
          this.markCartWithUpsell();
          this.showSuccess(btn, productTitle, card);
          this.trackUpsellAdd(variantId, productTitle, productPrice, data, deviceType);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { variant_id: variantId, product: data, from_upsell: true }
          }));
        }
      })
      .catch(error => {
        console.error('Cart Upsell: Erreur ajout panier', error);
        this.showError(btn, 'Une erreur est survenue');
      });
    },

    markCartWithUpsell: function() {
      var cartUpdateUrl = window.theme && window.theme.routes && window.theme.routes.cartChange
        ? window.theme.routes.cartChange.replace('/change.js', '/update.js')
        : '/cart/update.js';

      fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { 'contains_upsell': 'true' } })
      })
      .then(response => response.json())
      .then(() => console.log('Cart Upsell: Attribut "contains_upsell" ajouté'))
      .catch(error => console.error('Cart Upsell: Erreur attribut', error));
    },

    showSuccess: function(btn, productTitle, card) {
      btn.classList.remove(classes.loading);
      btn.classList.add(classes.success);
      console.log('Cart Upsell: Produit ajouté -', productTitle);

      setTimeout(function() {
        if (card) {
          card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          card.style.opacity = '0';
          card.style.transform = 'translateX(8px)';
          setTimeout(function() { card.remove(); }, 300);
        }
      }, 600);
    },

    showError: function(btn, message) {
      btn.classList.remove(classes.loading);
      if (message) { alert(message); }
      console.error('Cart Upsell: Erreur -', message);
    },

    trackUpsellAdd: function(variantId, productTitle, productPrice, productData, deviceType) {
      var priceInEuros = productPrice ? parseFloat(productPrice) / 100 : 0;

      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', {
          currency: 'EUR',
          value: priceInEuros,
          items: [{ item_id: variantId, item_name: productTitle, item_category: 'Upsell', price: priceInEuros, quantity: 1 }]
        });
        gtag('event', 'upsell_add_to_cart', {
          variant_id: variantId, product_title: productTitle, value: priceInEuros, device_type: deviceType
        });
      }

      if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Upsell', 'Add to Cart', productTitle, priceInEuros);
      }

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'upsell_add_to_cart',
          device_type: deviceType,
          ecommerce: {
            currencyCode: 'EUR',
            add: { products: [{ id: variantId, name: productTitle, price: priceInEuros, quantity: 1, dimension1: 'Upsell' }] }
          }
        });
      }
    }
  };

  function init() {
    if (document.readyState !== 'loading') {
      new CartDrawerUpsell();
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        new CartDrawerUpsell();
      });
    }
  }

  init();

})();
